import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalComponentsModule} from '../global-components/global-components.module';
import {SharedComponentsModule} from './presentation/shared-components/shared-components.module';
import {BusinessLogicFacade} from './business-logic/business-logic.facade';
import {BusinessRequirementsInjectionToken} from './presentation/business-logic.requirements';
import { PlansControllerModule } from './presentation/plans-controller/plans-controller.module';
import { PlansChosenModule } from './presentation/plans-chosen/plans-chosen.module';
import { SharedService } from '../lib/shared-service';


@NgModule({
    imports: [
        BusinessLogicFacade,
        CommonModule,
        GlobalComponentsModule,
        SharedComponentsModule,
        PlansControllerModule,
        PlansChosenModule
    ],
    providers: [
        {
            provide: BusinessRequirementsInjectionToken,
            useClass: BusinessLogicFacade
        },
        SharedService
    ],
    exports: []
})
export class UserPlansFeatureModule {}
